<template>
  <div class="content--sinoreg eProtocolo p-1">
    <h4 class="eProtocolo_title">
      Pendência e-Protocolo - Arquivo Estruturado de {{ tipoRegistro }}
    </h4>
    <IdentificacaoSolicitacao :arquivo-estruturado="arquivoEstruturado.solicitacao" />
    
    <template v-if="isNascimento">
      <DadosNascimento :arquivo-estruturado="arquivoEstruturado" />
      <Genitores :arquivo-estruturado="arquivoEstruturado.registro.filiacao"
                 :tipo-registro="'nascimento'" />
      <Declarante :arquivo-estruturado="arquivoEstruturado.registro.declarante" 
                  :tipo-registro="'nascimento'" />
      <Endereco :arquivo-estruturado="arquivoEstruturado.registro.declarante.endereco" />
    </template>
    
    <template v-else-if="isObito">
      <Falecido :arquivo-estruturado="arquivoEstruturado.registro.falecido" />
      <Conjuge v-if="arquivoEstruturado.registro.falecido.conjuge"
               :arquivo-estruturado="arquivoEstruturado.registro.falecido.conjuge" />
      <Endereco :arquivo-estruturado="arquivoEstruturado.registro.falecido.endereco_residencia_falecido" />
      <Genitores :arquivo-estruturado="arquivoEstruturado.registro.falecido.filiacao" 
                 :tipo-registro="'obito'" />
      <Declarante :arquivo-estruturado="arquivoEstruturado.registro.declarante" 
                  :tipo-registro="'obito'" />
      <DadosObito :arquivo-estruturado="arquivoEstruturado.registro.dados_falecimento" />
      <Documentos :arquivo-estruturado="arquivoEstruturado.registro" />
      <Filhos v-if="arquivoEstruturado.registro.deixou_filhos"
              :arquivo-estruturado="arquivoEstruturado.registro.filhos" />
    </template>

    <AcoesSolicitacao :tipo-registro="tipoRegistro" />
  </div>
</template>

<script>
  /* components */
  import IdentificacaoSolicitacao from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/IdentificacaoSolicitacao'
  import DadosNascimento from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/DadosNascimento'
  import Genitores from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/Genitores'
  import Declarante from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/Declarante'
  import Endereco from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/Endereco'
  import AcoesSolicitacao from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/AcoesSolicitacao'
  import Falecido from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/Falecido'
  import Conjuge from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/Conjuge'
  import DadosObito from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/DadosObito'
  import Documentos from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/Documentos'
  import Filhos from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/Filhos'

  /* libraries */
  import { mapGetters } from 'vuex'

  export default {
    name: 'ArquivosEstruturados',
    components: {
      IdentificacaoSolicitacao,
      DadosNascimento,
      Genitores,
      Declarante,
      Endereco,
      AcoesSolicitacao,
      Falecido,
      Conjuge,
      DadosObito,
      Documentos,
      Filhos
    },
    computed: {
      ...mapGetters({
        arquivoEstruturado: 'eProtocolo/getArquivoEstruturado'
      }),
      tipoRegistro () {
        const tipoRegistro = this.arquivoEstruturado.solicitacao.tipo_registro
        
        if (tipoRegistro === 'obito') return 'óbito'
        return tipoRegistro
      },
      isNascimento () {
        return this.tipoRegistro === 'nascimento'
      },
      isObito () {
        return this.tipoRegistro === 'óbito'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.eProtocolo {
  &_title {
    background-color: $sinoreg-blue;
    color: $color-white;
    font-size: pxToRem(24);
    font-weight: 500;
    padding: pxToRem(10) pxToRem(20);
  }
}
</style>